import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngxs/store';

import { AuthState } from '../../state/auth.state';
import { isPlatformServer } from '@angular/common';

@Injectable()
export class AuthGuard {

  constructor(
    private router: Router,
    private store: Store,
    @Inject(PLATFORM_ID) private platformId: object
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (isPlatformServer(this.platformId)) {
      return false;
    }

    if (this.store.selectSnapshot(AuthState.isAuthenticated)) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    //this.router.navigate(['/auth/autentificare'], { queryParams: { returnUrl: state.url } });
    return this.router.createUrlTree(['/auth/autentificare'], { queryParams: { returnUrl: state.url } });;
  }
}
